export const CATEGORY_STYLES = {
  "Web (SQLi, XSS, CSRF)": { color: "#00ff66", label: "WEB", ring: "rgba(0,255,102,0.4)" },
  Network: { color: "#00e5ff", label: "NETWORK", ring: "rgba(0,229,255,0.4)" },
  "Social Engineering / Phishing": { color: "#f59e0b", label: "SOCIAL", ring: "rgba(245,158,11,0.4)" },
  Malware: { color: "#ef4444", label: "MALWARE", ring: "rgba(239,68,68,0.4)" },
  Wireless: { color: "#a855f7", label: "WIRELESS", ring: "rgba(168,85,247,0.4)" },
};

export const SEVERITY_STYLES = {
  Critical: { color: "#ef4444", bg: "rgba(239,68,68,0.12)" },
  High: { color: "#f59e0b", bg: "rgba(245,158,11,0.12)" },
  Medium: { color: "#00e5ff", bg: "rgba(0,229,255,0.12)" },
  Low: { color: "#94a3b8", bg: "rgba(148,163,184,0.12)" },
};

const resolveCategory = (category) => {
  const c = (category || "").toLowerCase();
  if (c.includes("web") || c.includes("sql") || c.includes("xss") || c.includes("csrf") || c.includes("ssrf"))
    return CATEGORY_STYLES["Web (SQLi, XSS, CSRF)"];
  if (c.includes("phish") || c.includes("social")) return CATEGORY_STYLES["Social Engineering / Phishing"];
  if (c.includes("malware") || c.includes("ransom") || c.includes("virus")) return CATEGORY_STYLES.Malware;
  if (c.includes("wireless") || c.includes("wifi") || c.includes("wpa")) return CATEGORY_STYLES.Wireless;
  return CATEGORY_STYLES.Network;
};

export const CategoryBadge = ({ category }) => {
  const s = CATEGORY_STYLES[category] || resolveCategory(category);
  return (
    <span
      data-testid="category-badge"
      className="font-mono text-[10px] px-2 py-1 rounded uppercase tracking-widest font-semibold"
      style={{ color: s.color, border: `1px solid ${s.ring}`, background: `${s.color}12` }}
    >
      {s.label}
    </span>
  );
};

export const SeverityBadge = ({ severity }) => {
  const s = SEVERITY_STYLES[severity] || SEVERITY_STYLES.Medium;
  return (
    <span
      data-testid="severity-badge"
      className="font-mono text-[10px] px-2 py-1 rounded uppercase tracking-widest font-bold"
      style={{ color: s.color, background: s.bg, border: `1px solid ${s.color}55` }}
    >
      {severity}
    </span>
  );
};

export const SourceBadge = ({ source }) => {
  if (source === "exploit-db")
    return (
      <span
        data-testid="source-badge-edb"
        className="font-mono text-[9px] px-1.5 py-0.5 rounded uppercase tracking-widest font-semibold"
        style={{ color: "#00e5ff", border: "1px solid rgba(0,229,255,0.4)", background: "rgba(0,229,255,0.08)" }}
      >
        EDB
      </span>
    );
  return null;
};
